<template>
  <Webview>
    <template v-if="step === 'default'">
      <Header title="忘記密碼" :back="back"></Header>
      <div class="wv_page _fill">
        <template v-for="(item, key) in form">
          <Control :passData="item" :update="update" :check="check"></Control>
        </template>
      </div>
      <div class="wv_button">
        <div class="main_btn _main" @click="submit">確認</div>
      </div>
    </template>
    <template v-else-if="step === 'result'">
      <Header title="忘記密碼"></Header>
      <ResultPage :submit="back">
        <template v-if="isSuccess">
          系統已將密碼設定信件寄至<br>
          {{form.email.value}}
        </template>
        <template v-else>
          此帳號尚未註冊<br>
          請返回首頁進行帳號註冊
        </template>
      </ResultPage>
    </template>
  </Webview>
</template>

<script>
//api
import { forgetPwdValue } from "@/api/auth";
export default {
  mixins: [
    require("@mix/form").default,
    require("./mixins/formData").default
  ],
  data() {
    return {
      step: "default",//default, result
      isSuccess: true
    }
  },
  methods: {
    back() {
      this.$router.push({ name: "login" }) //在 forgetPassword 頁面時,按下返回回到 login 頁面
    },
    submit() {
      this.checkAll();
      if (!this.isAllValid) return false;

      this.forgetPwdValue();
    },
    async forgetPwdValue() {
      try {
        const params = {
          email: this.email
        }
        const res = await forgetPwdValue(params);
        this.isSuccess = true;
      }
      catch (error) {
        this.isSuccess = false;
      }
      finally {
        this.step = "result";
      }
    }
  }
}
</script>

<style>
</style>